import type { WorkspaceResourceType } from './workspaceApi';

export interface WorkspaceEndpoint { url: string; type: WorkspaceResourceType; module: string; label: string }
const ontology = import.meta.env.VITE_ONTOLOGY_SERVICE_URL || 'http://localhost:8004';
export const workspaceEndpoints: WorkspaceEndpoint[] = [
  { url: `${ontology}/apps?kind=dashboard`, type: 'app', module: 'apps', label: 'Dashboards' },
  { url: `${ontology}/apps?kind=app`, type: 'app', module: 'apps-app', label: 'Aplicaciones' },
  { url: `${ontology}/apps?kind=document`, type: 'app', module: 'apps', label: 'Documentos' },
  { url: `${ontology}/apps?kind=solution_design`, type: 'app', module: 'apps', label: 'Diseño de soluciones' },
  { url: `${import.meta.env.VITE_PIPELINE_SERVICE_URL || 'http://localhost:8002'}/pipelines`, type: 'pipeline', module: 'pipelines', label: 'Pipelines' },
  { url: `${import.meta.env.VITE_LOGIC_SERVICE_URL || 'http://localhost:8012'}/logic/functions`, type: 'function', module: 'logic', label: 'Logic Studio' },
  { url: `${import.meta.env.VITE_AGENT_SERVICE_URL || 'http://localhost:8013'}/agents`, type: 'agent', module: 'agents', label: 'Agent Studio' },
  { url: `${ontology}/object-types`, type: 'object_type', module: 'ontology', label: 'Ontología' },
  { url: `${ontology}/notebooks`, type: 'notebook', module: 'workbench', label: 'Workbench' },
  { url: `${import.meta.env.VITE_CONNECTOR_SERVICE_URL || 'http://localhost:8001'}/connectors`, type: 'connector', module: 'connectors', label: 'Fuentes de datos' },
];

export function endpointType(input: string): WorkspaceResourceType | undefined {
  const url = new URL(input, window.location.origin);
  const endpoints = [...workspaceEndpoints,
    { url: `${import.meta.env.VITE_ANALYTICS_SERVICE_URL || 'http://localhost:8015'}/explore/object-types`, type: 'object_type' as const },
    { url: `${ontology}/apps/recent-generated`, type: 'app' as const },
  ];
  return endpoints.find(endpoint => {
    const candidate = new URL(endpoint.url, window.location.origin);
    return candidate.origin === url.origin && candidate.pathname === url.pathname.replace(/\/$/, '');
  })?.type;
}
